import IQuestion from '@/types/IQuestion';
import QuestionBasic from './components/QuestionBasic/QuestionBasic';
import QuestionLocation from './components/QuestionLocation/QuestionLocation';

/**
 * This same interface is shared among the "subtypes"
 */
export type IQuestionProps = IQuestion & {
	isLoading: boolean;
	onChange: (q: IQuestion) => void;
	onDelete: (q: { id: string }) => void;
};

export default function Question(props: IQuestionProps) {
	switch (props.type) {
		case 'PHONE':
		case 'TEXT':
		case 'EMAIL':
		case 'IMAGE':
			return <QuestionBasic {...props} />;
		case 'LOCATION':
			return <QuestionLocation {...props} />;
		default:
			return null;
	}
}
